import { AssetDto, AssetVersionDto, GalleryDto } from '@nusign/picflow-backend-types';
import { ScreenSizes } from '../../classes/screen-sizes.class';
import { browserRenderableExtensions } from '../../consts';
import { getAllowedDownloadSizes } from '../../lib/convert-gallery-download-size';
import { IsIos } from '../../lib/is-ios';

export const showIosDownloadMenu = (
  gallery: GalleryDto,
  permissions: GalleryDto['permissions'],
  asset: AssetDto,
  version?: AssetVersionDto
) => {
  if (!IsIos()) return false;
  if (ScreenSizes.screenSize() !== 'mobile') return false;
  if (!version) version = asset.version_data;
  const resp = getAllowedDownloadSizes(gallery.download_media_size, permissions, asset, version);
  const allowedSizes = [...resp.sizes, ...(resp.allowOriginalDownload ? [{ name: 'original', size: 0 }] : [])];
  if (!allowedSizes.length) return false;
  if (allowedSizes.length > 1) return true;
  if (allowedSizes[0].name !== 'original') return true;
  const extension = version.asset_name.split('.').pop()?.toLowerCase();
  return browserRenderableExtensions.includes(extension);
};
